export default __webpack_public_path__ + "38d7330d7db47b97a9fd1091d64ef04e.png";